import React from "react"
import Header, {Footer} from './header'


var services_head = {__html:
   `


<head>
<meta http-equiv="Content-type" content="text/html; charset=utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<meta name="keywords" content="">
<meta name="description" content="Datum &amp; Co. has a wide array of services that can help any company looking to integrate data into their workflow, product, or long-term planningWhether you have a specific application in mind, or you simply want to explore your data, Datum &amp; Co. can help you enrich your business. Datum &amp; Co. will guide you from pre-planning and roadmapping, all the way to product deployment and maintenance.">
<title>Datum · Services</title>



 <style>
p,h3,li {
color: rgba(66,66,66,1);
}

h2 {
  color: rgba(135, 135, 135, 1);
  font-style: italic;
  font-size: 24px;
  font-weight: normal;
  text-align: center;
  margin-bottom: 20px;
}
h3 {
  display: inline-block;
  border-bottom: 3px solid rgb(53, 97, 135);
}
em {
  font-weight: bold;
  font-style: italic;
}
.serviceblock {
   padding-top: 30px;
   padding-bottom: 30px;
}
.serviceborder {
  width: 55%;
  display: inline-block;
  //border: 2px solid rgb(35, 35, 35);
  border-radius: 15px 15px;
  background-color: rgb(198, 206, 243);
}
.service {
  margin: 0px 20px 0px 20px;
}
.diagram {
  width: 40%;
  display: inline-block;
  margin: 0px 20px 0px 20px;
}
</style> 



<script>

  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

  ga('create', 'UA-79902690-1', 'auto');
  ga('send', 'pageview');


</script>



<!--[if lt IE 9]>
<script src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/static/js/html5shiv.js"></script>
<script src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/static/js/respond.min.js"></script>
<![endif]-->
<script src="https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.6/d3.min.js"> </script>
<script src="https://d3js.org/d3.v4.min.js"></script>

</head>
      `}


var d3_str = `
var svg = d3.selectAll("#diagram1").append("svg");
var margin = {top: 40, right: 40, bottom: 40, left: 40};

var width = 400;
var height = 400;

svg.attr("viewBox","0 0 575 450")
   .attr("width", "550");

var g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

var y = d3.scalePoint()
    .domain(d3.range(10))
    .range([0, height]);

var z = d3.scaleLinear()
    .domain([10, 0])
    .range(["hsl(62,100%,90%)", "hsl(228,30%,20%)"])
    .interpolate(d3.interpolateHcl);

var speedCircles = 3000;
var colors = ["brown", "steelblue", "olive", "coral", "aqua", "#FFE5B4", "indianred"];
g.selectAll("circle.first")
  .data(y.domain())
  .enter().append("circle")
    .attr('class', 'first')
    .attr("r", 1)
    .attr("cx", 0)
    .attr("cy", 80)
    .style("fill", "brown")
  .transition()
    .duration(speedCircles)
    .delay(function(d) { return d * 80; })
    .on("start", function repeat() {
        d3.active(this)
     .attr("r", 10)
           .attr("cx", width/2)
            .attr("cy", height/2)
            .style("opacity", 0)
    .transition()
    .duration(0)
    .attr("r", 1)
            .attr("cx", 0)
            .attr("cy", 80)
            .style("opacity", 1)
          .transition()
    .duration(speedCircles)
            .on("start", repeat);
      });

 g.selectAll("circle.second")
  .data(y.domain())
    .enter().append("circle")
    .attr('class', 'second')
    .attr("r", 1)
    .attr("cx", width)
    .attr("cy", 80)
    .style("fill", "olive")
  .transition()
    .duration(speedCircles)
    .delay(function(d) { return d * 80; })
    .on("start", function repeat() {
        d3.active(this)
    .attr("r", 10)
            .attr("cx", width/2)
            .attr("cy", height/2)
            .style("opacity", 0)
    .transition()
    .duration(0)
    .attr("r", 1)
            .attr("cx", width)
            .attr("cy", 80)
            .style("opacity", 1)
          .transition()
    .duration(speedCircles)
            .on("start", repeat);
    });

 g.selectAll("circle.third")
  .data(y.domain())
    .enter().append("circle")
    .attr('class', 'third')
    .attr("r", 1)
    .attr("cx", width/2)
    .attr("cy", 80)
    .style("fill", "coral")
  .transition()
    .duration(speedCircles)
    .delay(function(d) { return d * 80; })
    .on("start", function repeat() {
        d3.active(this)
    .attr("r", 10)
            .attr("cy", height/2)
            .style("opacity", 0)
    .transition()
    .duration(0)
    .attr("r", 1)
            .attr("cy", 80)
            .style("opacity", 1)
          .transition()
    .duration(speedCircles)
            .on("start", repeat);
    });

 g.selectAll("circle.fourth")
  .data(y.domain())
    .enter().append("circle")
    .attr('class', 'fourth')
    .attr("r", 1)
    .attr("cx", width)
    .attr("cy", height-50)
    .style("fill", "#FFE5B4")
  .transition()
    .duration(speedCircles)
    .delay(function(d) { return d * 80; })
    .on("start", function repeat() {
        d3.active(this)
    .attr("r", 10)
    .attr("cx", width/2)
            .attr("cy", height/2)
            .style("opacity", 0)
    .transition()
    .duration(0)
    .attr("r", 1)
    .attr("cx", width)
            .attr("cy", height-50)
            .style("opacity", 1)
          .transition()
    .duration(speedCircles)
            .on("start", repeat);
    });

 g.selectAll("circle.fifth")
  .data(y.domain())
    .enter().append("circle")
    .attr('class', 'fifth')
    .attr("r", 1)
    .attr("cx", 0)
    .attr("cy", height-50)
    .style("fill", "indianred")
  .transition()
    .duration(speedCircles)
    .delay(function(d) { return d * 80; })
    .on("start", function repeat() {
        d3.active(this)
     .attr("r", 10)
           .attr("cx", width/2)
            .attr("cy", height/2)
            .style("opacity", 0)
    .transition()
    .duration(0)
    .attr("r", 1)
            .attr("cx", 0)
            .attr("cy", height-50)
            .style("opacity", 1)
          .transition()
    .duration(speedCircles)
            .on("start", repeat);
    });

 g.selectAll("circle.sixth")
  .data(y.domain())
    .enter().append("circle")
    .attr('class', 'sixth')
    .attr("r", 1)
    .attr("cx", 0)
    .attr("cy", height/2)
    .style("fill", "aqua")
  .transition()
    .duration(speedCircles)
    .delay(function(d) { return d * 80; })
    .on("start", function repeat() {
        d3.active(this)
     .attr("r", 10)
           .attr("cx", width/2)
            .style("opacity", 0)
    .transition()
    .duration(0)
    .attr("r", 1)
            .attr("cx", 0)
            .style("opacity", 1)
          .transition()
    .duration(speedCircles)
            .on("start", repeat);
    });

 g.selectAll("circle.seventh")
  .data(y.domain())
    .enter().append("circle")
    .attr('class', 'seventh')
    .attr("r", 1)
    .attr("cx", width)
    .attr("cy", height/2)
    .style("fill", "steelblue")
  .transition()
    .duration(speedCircles)
    .delay(function(d) { return d * 80; })
    .on("start", function repeat() {
        d3.active(this)
     .attr("r", 10)
           .attr("cx", width/2)
            .style("opacity", 0)
    .transition()
    .duration(0)
    .attr("r", 1)
            .attr("cx", width)
            .style("opacity", 1)
          .transition()
    .duration(speedCircles)
            .on("start", repeat);
    });

 g.selectAll("circle.eighth")
  .data(y.domain())
    .enter().append("circle")
    .attr('class', 'eighth')
    .attr("r", 0)
    .attr("cx", width/2)
    .attr("cy", height/2)
    .style("fill", function(d,i) {return colors[i%colors.length];})
  .transition()
    .duration(speedCircles)
    .delay(function(d) { return d * 80 + speedCircles/2 + 250; })
    .on("start", function repeat() {
        d3.active(this)
     .attr("r", 10)
            .attr("cy", height-80)
            .style("opacity", 0)
    .transition()
    .duration(0)
    .attr("r", 1)
            .attr("cy", height/2)
            .style("opacity", 1)
          .transition()
    .duration(speedCircles)
            .on("start", repeat);
    });

var analysis = ["Analytics Dashboard",
        "Customer Segmentation",
        "Forecasting",
        "Predictive analytics"];
var images = ["https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/galleries/analyticsdashboard.png",
               "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/galleries/customersegmentation.png",
               "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/galleries/forecast.png",
               "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/galleries/campaigneffectiveness.png"];

var speedScale = 6000


svg.append("rect")
      .attr("stroke","black")
          .attr("rx", 5)
    .attr("ry", 5)
    .style("fill","white")
      .attr("x", width/2-30)
      .attr("y", height/2+10)
      .attr("width", 150)
      .attr("height", 50);

    svg.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/s3.png")
      .attr("x", width/2-30)
      .attr("y", height/2-40)
      .attr("width", 150)
      .attr("height", 150);

    svg.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/mailchimp.png")
      .attr("x", 0)
      .attr("y", 40)
      .attr("width", 100)
      .attr("height", 100);
    
    
    svg.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/googleanalytics.png")
      .attr("x", width/2-20)
      .attr("y", 0)
      .attr("width", 130)
      .attr("height", 130);

    svg.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/shoppingcart.png")
      .attr("x", width+10)
      .attr("y", 40)
      .attr("width", 50)
.attr("height", 50);

    svg.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/mail-icon.png")
      .attr("x", width+10)
      .attr("y", height)
      .attr("width", 50)
.attr("height", 50);

    svg.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/slack_rgb.png")
      .attr("x", 0)
      .attr("y", height-30)
      .attr("width", 100)
.attr("height", 100);

    svg.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/twitter_logo_blue.png")
      .attr("x", 0)
      .attr("y", height/2)
      .attr("width", 75)
.attr("height", 75);

    svg.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/sfdc_logo.png")
      .attr("x", width+10)
      .attr("y", height/2)
      .attr("width", 75)
.attr("height", 75);

    svg.append("text")
       .text("Analytics/Data mining")
       .style("font-weight","bold")
       .style("font-size","20")
       .style("fill",d3.rgb(66,66,66))
       .style("text-anchor","middle")
       .attr("x", width/2+45)
       .attr("y", height-30);

   

var svg2 = d3.selectAll("#diagram2").append("svg");
//var margin = {top: 40, right: 40, bottom: 40, left: 40};

//var width = 400;
//var height = 400;

svg2.attr("viewBox","0 0 575 450")
   .attr("width", "550");

var g2 = svg2.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");



g2.selectAll("text.analysis")
  .data(analysis)
    .enter().append("text")
    .attr('class', 'analysis')
    .text(function (d) {return d;})
    .style("font-size","24")
    .style("font-weight","bold")
    .style("fill",d3.rgb(66,66,66))
    .style("text-anchor","middle")
    .attr("x", -100)
    .attr("y", height-70)
    .attr("opacity", 0)
    .transition()
    .duration(speedScale)
    .delay(function(d,i) { return i * speedScale; })
    .on("start", function repeat() {
        d3.active(this)
           .attr("x", width/2)
           .style("opacity", 1)
           .transition()
           .duration(speedScale)
             .attr("x", width+100)
             .style("opacity", 0)
           .transition()
           .duration(speedScale*(analysis.length-2))
             .attr("x", -100)
           .transition()
           .duration(speedScale)
             .on("start", repeat);
         });

g2.selectAll(".images")
  .data(images)
    .enter().append("svg:image")
    .attr('class', 'images')
    .attr("xlink:href", function(d) {return d;})
    .attr("x", -600)
    .attr("y", -180)
      .attr("width", 480)
     .attr("height", 600)
    .attr("opacity", 0)
    .transition()
    .duration(speedScale)
    .delay(function(d,i) { return i * speedScale; })
    .on("start", function repeat() {
        d3.active(this)
           .attr("x", width/2-240)
           .style("opacity", 1)
           .transition()
           .duration(speedScale)
             .attr("x", width+600)
             .style("opacity", 0)
           .transition()
           .duration(speedScale*(images.length-2))
             .attr("x", -600)
           .transition()
           .duration(speedScale)
             .on("start", repeat);
         });




var svg3 = d3.selectAll("#diagram3").append("svg");
//var margin = {top: 40, right: 40, bottom: 40, left: 40};

//var width = 400;
//var height = 400;

svg3.attr("viewBox","0 0 575 450")
   .attr("width", "550");

var g3 = svg3.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

var y3 = d3.scalePoint()
    .domain(d3.range(10))
    .range([0, height]);

var z3 = d3.scaleLinear()
    .domain([10, 0])
    .range(["hsl(62,100%,90%)", "hsl(228,30%,20%)"])
    .interpolate(d3.interpolateHcl);


var analysis3 = ["Custom Web Applications",
        "RESTful API"]
var images3 = ["https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/galleries/customapp.png",
               "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/galleries/restfulapi.png"];

g3.selectAll("text.analysis")
  .data(analysis3)
    .enter().append("text")
    .attr('class', 'analysis')
    .text(function (d) {return d;})
    .style("font-weight","bold")
    .style("fill",d3.rgb(66,66,66))
    .style("text-anchor","middle")
    .attr("x", -100)
    .attr("y", height)
    .attr("opacity", 0)
    .transition()
    .duration(speedScale)
    .delay(function(d,i) { return i * speedScale; })
    .on("start", function repeat() {
        d3.active(this)
           .attr("x", width/2)
           .style("opacity", 1)
           .transition()
           .duration(speedScale)
             .attr("x", width+100)
             .style("opacity", 0)
           .transition()
           .duration(speedScale*(analysis3.length-2))
             .attr("x", -100)
           .transition()
           .duration(speedScale)
             .on("start", repeat);
         });

g3.selectAll(".images")
  .data(images3)
    .enter().append("svg:image")
    .attr('class', 'images')
    .attr("xlink:href", function(d) {return d;})
    .attr("x", -100)
    .attr("y", height-215)
      .attr("width", 300)
     .attr("height", 200)
    .attr("opacity", 0)
    .transition()
    .duration(speedScale)
    .delay(function(d,i) { return i * speedScale; })
    .on("start", function repeat() {
        d3.active(this)
           .attr("x", width/2-150)
           .style("opacity", 1)
           .transition()
           .duration(speedScale)
             .attr("x", width+100)
             .style("opacity", 0)
           .transition()
           .duration(speedScale*(images3.length-2))
             .attr("x", -100)
           .transition()
           .duration(speedScale)
             .on("start", repeat);
         });


    svg3.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/aws_logo.png")
      .attr("x", width/2-30)
      .attr("y", height/3-50)
      .attr("width", 150)
      .attr("height", 150);

    svg3.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/docker.png")
      .attr("x", 0)
      .attr("y", 20)
      .attr("width", 100)
      .attr("height", 100);
    
    
    svg3.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/python-logo-master-v3-tm.png")
      .attr("x", width/2-20)
      .attr("y", 0)
      .attr("width", 130)
      .attr("height", 130);

    svg3.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/flask.png")
      .attr("x", 0)
      .attr("y", height/3)
      .attr("width", 100)
      .attr("height", 100);

    svg3.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/mysql.png")
      .attr("x", width)
      .attr("y", height/3)
      .attr("width", 100)
      .attr("height", 100);

    svg3.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/mongodb-logo-rgb.png")
      .attr("x", width-20)
      .attr("y", 60)
      .attr("width", 100)
      .attr("height", 100);

    svg3.append("svg:image")
    .attr("xlink:href", "https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/media/uploads/icons/scikit-learn-logo.png")
      .attr("x", width)
      .attr("y", 0)
      .attr("width", 100)
      .attr("height", 100);
`


class Body extends React.Component {
   componentDidMount() {
     window.eval(d3_str);
   }

   render () {
      return (<div dangerouslySetInnerHTML={{__html: `

<body id="body">





<section class="peter-river" style="background: #2980b9 !important; padding-top: 50px; padding-bottom: 50px;" id="title">
        <div class="container">
            <div class="row">
                <div class="col-sm-6">
                    <h1>
Services
</h1>
                    
                </div>
                <div class="col-sm-6">
                    <ul class="breadcrumb pull-right">
                        <li id="breadcrumb-menu-services-1"
        class="active">Services</li>
                    </ul>
                </div>
            </div>
        </div>
   </section>


<div class="container">





</div>


<section  id='d3_container' class="container" 
         style="padding-top: 45px; padding-bottom: 30px;">

<!-- fontawecome <i> tags have to go here --> 

<h2>Datum &amp; Co. has a wide array of services that can help any company&nbsp;looking to integrate data into their workflow, product, or long-term planning</h2>
<p>Whether you have a specific application&nbsp;in mind, or you simply want to explore your data, Datum &amp; Co. can help you enrich your business. &nbsp;Datum &amp; Co. will guide you from pre-planning and roadmapping,&nbsp;all the way to product&nbsp;deployment and maintenance.</p>
<p>While each individual engagement with Datum &amp; Co. will be tailored to your specific needs, here are some basic frameworks&nbsp;to get you started with planning your company's next data pivot.</p>
<p>&nbsp;</p>
<div class="serviceblock">
<div class="serviceborder">
<div class="service">
<h3><a name="anchor_1"></a>Data Pipeline and Data Warehouse Building Service</h3>
<p>This service is offered to businesses with data from multiple scattered sources. &nbsp;Automating the collection and integration of this data is the first step for a company to become data-centric. &nbsp;</p>
<p>This engagement is generally best suited for&nbsp;new businesses, or established businesses with data from many sources but no integrated way to utilize this data to discover insights.</p>
<p><em>What we Deliver:</em></p>
<ol>
<li>A centralized database</li>
<li>Worker scripts to run routinely to collect and process data</li>
</ol>
<p><em>Example:</em></p>
<p>A retail business client uses various cloud services from different sources and thus has unorganized data from shopping carts, newsletter subscribing platforms, customer emails, customer service chat channels and more. &nbsp;Datum &amp; Co. can design the data pipelines to automate the data gathering process and&nbsp;mine&nbsp;the integrated data. &nbsp;Click here to learn more about a client who used this service.</p>
<p>&nbsp;</p>
</div>
</div>
<div id="diagram1" class="diagram">&nbsp;</div>
</div>
<p>&nbsp;</p>
<div class="serviceblock">
<div class="serviceborder">
<div class="service">
<h3><a name="anchor_2"></a>Data Mining Service&nbsp;</h3>
<p>Similar to traditional data analysis for Business Intelligence, we provide <span style="font-weight: 400;">quantitatively</span>&nbsp;validated insights to expand, restructure, or improve the <span style="font-weight: 400;">efficiency</span> of your company. &nbsp;With Datum &amp; Co. this service package&nbsp;is powered by more sophisticated data science methods. &nbsp;With our expertise in machine learning, we can mine data from deeper layers and can discover insights that may be counterintuitive, or undetectable by simple A-B testing and&nbsp;conventional Business Intelligence techniques. &nbsp;These data sources can come from the existing data from the company, or from external sources such as news or social media.</p>
<p><em>What we Deliver:</em></p>
<ol>
<li>Reports or interactive dashboards to illustrate insights</li>
<li>Predictive models to enable data-driven decision making</li>
</ol>
<p><em>Examples:</em></p>
<p>Datum &amp; Co. can enable a E-commerce business to analyze the customer's shopping behavior, make market segments for target marketing, and discover potential markets.</p>
<p>We can also help&nbsp;a marketing team discover audience&nbsp;insights&nbsp;by analyzing and clustering Tweets pertaining to their product, allowing&nbsp;the team&nbsp;to quickly&nbsp;adapt&nbsp;their social media campaign accordingly.</p>
<p>&nbsp;</p>
</div>
</div>
<div id="diagram2" class="diagram">&nbsp;</div>
</div>
<p>&nbsp;</p>
<div class="serviceblock">
<div class="serviceborder">
<div class="service">
<h3><a name="anchor_3"></a>End-to-end Data Application Service</h3>
<p>This service is applying data science techniques and algorithms directly to a client's product, usually a software or a labor-intense service. &nbsp;This engagement can help&nbsp;startups whose products need machine learning as a core component (e.g., recommendation engine, price prediction, etc.) , or need machine learning to scale their services (e.g., labor-intense tasks such as assigning tags to messages.)</p>
<p><em>What we Deliver:</em></p>
<ol>
<li>An&nbsp;API that can be integrated with the client's core app</li>
</ol>
<p><em>Examples:</em></p>
<p>A SaaS company has an accounting app that will automatically categorize transactions. &nbsp;As the user base scales this task has to be automated via machine learning. &nbsp;Click here to learn more about a client who used this service.</p>
<p>A SaaS company has a product to analyze user reviews, and needs clustering models on the review data to analyze.</p>
<p>&nbsp;</p>
</div>
</div>
<div id="diagram3" class="diagram">&nbsp;</div>
</div>


</section>


 <script src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/static/js/jquery.prettyPhoto.js"></script>
 <script src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/static/js/jquery.isotope.min.js"></script>
 <script src="https://elasticbeanstalk-us-west-1-210231684987.s3.amazonaws.com/static/js/main.js"></script>





</body>
         `}} />);
           
   }
}



const Services = () => (
   <div>
      <div dangerouslySetInnerHTML={services_head} />
      <Header />
      <Body />
      <Footer />
      </div>
)
export default Services



/** WEBPACK FOOTER **
 ** ./src/pages/services.js
 **/